// extracted by mini-css-extract-plugin
export default {"treeItem":"categories_treeItem__VoxiB","name":"categories_name__8YtrS"};